export const getErrorMessage = (error) => {
  if (!error) return 'An unexpected error occurred';
  
  // Axios error with response data
  if (error.response?.data) {
    // If backend sends { detail: "message" } (from FastAPI/Flask/our Express setup)
    if (error.response.data.detail) {
      // Sometimes detail might be an array depending on validation frameworks
      if (Array.isArray(error.response.data.detail)) {
        return error.response.data.detail.map(err => err.msg || err).join(', ');
      }
      return error.response.data.detail;
    }
    
    // Fallbacks to generic message property
    if (error.response.data.message) {
      return error.response.data.message;
    }
    
    // In case backend sends a string directly
    if (typeof error.response.data === 'string') {
      return error.response.data;
    }
  }
  
  // Standard JS Error or fallback Axios error message
  if (error.message) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
};
